/**
 * Gamification Reducer
 * 
 * Gestisce lo stato della gamification in Redux:
 * - Profilo utente (punti, streak, tier)
 * - Stato di loading/error
 * - Visibilità modali
 * - Toast notifiche punti
 */

import { GAMIFICATION_TYPES } from '../actions/gamificationActions';

const initialState = {
  // Profilo gamification
  profile: null,
  
  // Stati di caricamento
  isLoading: false,
  isRecordingEvent: false,
  
  // Errori
  error: null,
  
  // Toast per punti guadagnati
  pointsToast: {
    visible: false,
    basePoints: 0,
    bonusPoints: 0,
    totalPoints: 0,
    eventType: null
  },
  
  // Visibilità modali
  modals: {
    onboarding: false,        // Modale primo accesso (studenti)
    parentOnboarding: false,  // Modale primo accesso (genitori)
    dailyReturn: false,       // Modale rientro giornaliero
  },
  
  // Step onboarding per genitori/gift
  stepOnboarding: {
    active: false,
    currentStep: 0,
  },
  
  // Ultimo risultato evento
  lastEventResult: null
};

const gamificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GAMIFICATION_TYPES.SET_PROFILE:
      return {
        ...state,
        profile: action.payload,
        isLoading: false,
        error: null
      };
      
    case GAMIFICATION_TYPES.SET_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };
      
    case GAMIFICATION_TYPES.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
      
    case GAMIFICATION_TYPES.RECORD_EVENT_START:
      return {
        ...state,
        isRecordingEvent: true,
        error: null
      };
      
    case GAMIFICATION_TYPES.RECORD_EVENT_SUCCESS:
      return {
        ...state,
        isRecordingEvent: false,
        lastEventResult: action.payload,
        // Aggiorna il profilo con i nuovi dati (usa fallback ai valori esistenti)
        profile: state.profile ? {
          ...state.profile,
          totalPointsLifetime: action.payload.totalPointsLifetime ?? state.profile.totalPointsLifetime,
          currentStreak: action.payload.currentStreak ?? state.profile.currentStreak,
          longestStreak: action.payload.longestStreak ?? state.profile.longestStreak,
          iconTier: action.payload.iconTier ?? state.profile.iconTier,
          onboardingChecklist: action.payload.onboardingChecklist ?? state.profile.onboardingChecklist,
          lastActiveDate: action.payload.lastActiveDate ?? state.profile.lastActiveDate,
          lastStreakDayAwarded: action.payload.lastStreakDayAwarded ?? state.profile.lastStreakDayAwarded,
          shields: action.payload.shields ?? state.profile.shields,
          exists: state.profile.exists
        } : null
      };
      
    case GAMIFICATION_TYPES.RECORD_EVENT_FAILURE:
      return {
        ...state,
        isRecordingEvent: false,
        error: action.payload
      };
      
    case GAMIFICATION_TYPES.SHOW_POINTS_TOAST:
      return {
        ...state,
        pointsToast: {
          visible: true,
          basePoints: action.payload.basePoints || 0,
          bonusPoints: action.payload.bonusPoints || 0,
          totalPoints: action.payload.totalPointsAwarded || 0,
          eventType: action.payload.eventType || null
        }
      };
      
    case GAMIFICATION_TYPES.HIDE_POINTS_TOAST:
      return {
        ...state,
        pointsToast: {
          ...state.pointsToast,
          visible: false
        }
      };
      
    case GAMIFICATION_TYPES.SET_MODAL_VISIBLE:
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.payload.modalType]: action.payload.isVisible
        }
      };
      
    case GAMIFICATION_TYPES.CLEAR_PROFILE:
      // Mantieni il toast visibile anche quando si fa clear del profilo
      // per evitare che scompaia durante transizioni di auth state
      return {
        ...initialState,
        pointsToast: state.pointsToast
      };
      
    case GAMIFICATION_TYPES.START_STEP_ONBOARDING:
      return {
        ...state,
        stepOnboarding: {
          active: true,
          currentStep: 0
        }
      };
      
    case GAMIFICATION_TYPES.NEXT_STEP_ONBOARDING:
      return {
        ...state,
        stepOnboarding: {
          ...state.stepOnboarding,
          currentStep: state.stepOnboarding.currentStep + 1
        }
      };
      
    case GAMIFICATION_TYPES.END_STEP_ONBOARDING:
      return {
        ...state,
        stepOnboarding: {
          active: false,
          currentStep: 0
        }
      };
      
    default:
      return state;
  }
};

export default gamificationReducer;

